import React, { createContext, useContext } from "react"

const TelemetryContext = createContext()

export function useTelemetry(localTelemetry) {
  const contextTelemetry = useContext(TelemetryContext)

  if (localTelemetry === false) return false
  if (contextTelemetry === false) return localTelemetry || false

  return { ...contextTelemetry, ...localTelemetry }
}

export const Telemetry = ({ value, children }) => {
  const parentTelemetry = useContext(TelemetryContext)

  let mergedTelemetry
  if (value === false) {
    // This component disabled telemetry for its subtree.
    mergedTelemetry = false
  } else if (parentTelemetry === false) {
    // A parent disabled telemetry, but this component provides its own.
    mergedTelemetry = value || false
  } else {
    // Both parent and local telemetry exist. Merge them.
    mergedTelemetry = { ...parentTelemetry, ...value }
  }

  return (
    <TelemetryContext.Provider value={mergedTelemetry}>
      {children}
    </TelemetryContext.Provider>
  )
}
